/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

/**
 * Contient les textes utilisés dans le logiciel en langue Française
 * @type mtg32.texte_fr
 */
const texte_fr = {
  step: "pas",
  var1: "Changement de la valeur de la variable ",
  var2: "Entrez une valeur comprise entre ",
  et: " et ",
  Incorrect: "Entrée non valide",
//Chaînes servant suivant la langue à reconstruire les formules mathématiques
  abs: "abs",
  intgr: "int",
  sqrt: "sqrt",
  rac: "rac",
  sin: "sin",
  cos: "cos",
  tan: "tan",
  ln: "ln",
  exp: "exp",
  arctan: "arctan",
  arccos: "arccos",
  arcsin: "arcsin",
  ch: "ch",
  sh: "sh",
  th: "th",
  argch: "argch",
  argsh: "argsh",
  argth: "argth",
  rand: "rand",
  conj: "conj",
  arg: "arg",
  re: "re",
  im: "im",
  maxi: "max",
  mini: "min",
  gcd: "pgcd",
  lcm: "ppcm",
  ncr: "nCr",
  npr: "nPr",
  mod: "mod",
  si: "si",
  integrale: "integrale",
  fact: "fact",
  somme: "somme",
  produit: "produit",
  left: "gauche",
  right: "droit",

}

module.exports = texte_fr



// WEBPACK FOOTER //
// ./src/textes/textes_fr.js